<div class="report-page-container">
  <kehe-phoenix-alert-layout>
    @if ((alert$ | async)?.message !== null) {
      <kehe-phoenix-alert
        (alertEvent)="handleAlertEvents($event)"
        [message]="(alert$ | async)?.message"
        [show]="(alert$ | async)?.message !== null"
        [type]="(alert$ | async)?.type"
        stick="true"
      >
      </kehe-phoenix-alert>
    }
  </kehe-phoenix-alert-layout>

  <kehe-phoenix-manage-list-page-title-layout pageTitle="Reporting">
    <ng-template #actionsBlock>
      <!-- Help Button + Modal -->
      <kehe-phoenix-help-button-modal-block
        [videos]="helpVideos"
      ></kehe-phoenix-help-button-modal-block>
    </ng-template>
  </kehe-phoenix-manage-list-page-title-layout>

  <div class="row">
    <div class="col d-flex flex-row-reverse">
      <div class="w-50">
        <kendo-label text="Report"></kendo-label>
        <kendo-dropdownlist
          [data]="reportOptions$ | async"
          valueField="value"
          textField="label"
          (valueChange)="reportSelectionChanged($event)"
        >
        </kendo-dropdownlist>
      </div>
    </div>
  </div>

  <div class="row report-viewer-row">
    @if (reportsVisible$ | async) {
      <div class="col-sm-12">
        <div class="report">
          <div class="iframe-container">
            <iframe title="embedded-report" [src]="reportUrl"> </iframe>
          </div>
        </div>
      </div>
    }
  </div>

  @if ((reportsVisible$ | async) === false) {
    <div class="row">
      <div class="col-sm-12">
        <div class="report">
          <div class="instructions-container">
            <div class="fas fa-seedling seedling"></div>
            <h3>No Report Selected</h3>
            <ol class="steps-list">
              <li>Select your report in the upper right</li>
              <li>Start getting reports</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  }
</div>
